import { ChangeDetectionStrategy, Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { environment } from '~env/environment';
import { CustomHubCategory, CustomHubBanner } from '~app/modules/custom-hub/models';
import { APP_CATEGORY_ROUTE } from '~shared/constants';
import { viewportSizeDetector } from '~app/modules/generic/helpers';
import { ApplicationEventService } from '~shared/modules/application-event/services';
import { HubPageCardClickEvent } from '~shared/modules/application-event/models/hub-page-card-click-event.model';

@Component({
  selector: 'app-custom-hub-card',
  templateUrl: './custom-hub-card.component.html',
  styleUrls: ['./custom-hub-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CustomHubCardComponent implements OnInit {
  @Input() category: CustomHubCategory;
  @Output() categoryClick = new EventEmitter<CustomHubCategory>();

  defaultCategoryImage = `${environment.cdnBaseUrl()}/images/product-catalog-placeholder.png`;
  marketplaceLink = environment.appBaseUrl();
  categoryRoute = `/${APP_CATEGORY_ROUTE}`;
  categoryBanner: CustomHubBanner;
  viewportSize = null;

  constructor(private applicationEventService: ApplicationEventService) { }

  ngOnInit() {
    this.viewportSize = viewportSizeDetector(window.innerWidth);
    this.categoryBanner = this.getCategoryBanner(this.category.banners, this.viewportSize);
  }

  /**
   * @param event
   */
  @HostListener('window:resize', ['$event'])
  windowResizeListener(event?) {
    const viewportSize = viewportSizeDetector(window.innerWidth);
    if (this.viewportSize !== viewportSize) {
      this.viewportSize = viewportSize;
      this.categoryBanner = this.getCategoryBanner(this.category.banners, this.viewportSize);
    }
  }

  getCategoryBanner(banners: CustomHubBanner[], viewport: string) {
    return banners.find(banner => banner.viewport.toString() === viewport);
  }

  onCategoryClick(): void {
    this.categoryClick.emit(this.category);
    this.fireHubPageCardClickEvent({
      label: this.category.name,
      gtmCustom: {
        'content-name': window.location.pathname.split('/').pop()
      },
    });
  }

  private fireHubPageCardClickEvent(payload: any): void {
    this.applicationEventService.publish(
        new HubPageCardClickEvent(payload)
    );
  }
}
